module.exports = __webpack_public_path__ + "img/bessac_bg_03_.94149159.jpg";